<template>
  <div class="content" v-loading.fullscreen.lock="loading" element-loading-text="数据量巨大，请耐心等待..." element-loading-background="rgba(0, 0, 0, 0.8)">
    <search :params.sync="params" :showCharts="showCharts" />
    <div class="charts">
      <div class="chart" ref="deviceChart"></div>
      <div class="chart" ref="osChart"></div>
      <div class="chart" ref="browserChart"></div>
      <div class="chart" ref="engineChart"></div>
      <div class="chart" ref="screenChart"></div>
      <div class="chart" ref="typeChart"></div>
      <div class="chart" ref="ispChart"></div>
      <div class="chart" ref="regionChart"></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import qs from 'qs';

import search from '../../components/search';

import getRegionData from './getRegionData';

const legend = (chartData) => {
  return {
    x: 'center',
    y: 'bottom',
    data: chartData.map(b => b.key).sort((a, b) => {
      if (a === '其他') return 1;
      if (b === '其他') return -1;
      return 0;
    })
  }
};
const firstTooltip = {
  trigger: 'item',
  formatter: function(params) {
    return params.marker + params.name + " : " + params.value + ' ' +params.percent +"%";
  }
};
const secondTooltip = {
  trigger: 'item',
  formatter: function(params) {
    const { name, marker, value, percent } = params;
    const { browserName } = params.data;
    return `${browserName && browserName !== '其他' ? browserName + '<br/>' : ''} ${marker} ${name.indexOf('其他') === -1 ? name : '其他'} : ${value} ${percent}%`;
  }
};
const firstSeries = (chartData) => {
  return {
    type:'pie',
    selectedMode: 'single',
    radius: [0, '40%'],
    label: {
      normal: {
        position: 'inner'
      }
    },
    labelLine: {
      normal: {
        show: false
      }
    },
    data: chartData.map(b => {
      return {
        name: b.key,
        value: b.doc_count
      }
    })
  }
}
const secondSeries = (chartData) => {
  return {
    type:'pie',
    radius: ['50%', '70%'],
    label: {
      formatter: function(params) {
        return `${params.name.indexOf('其他') !== -1 ? '' : params.data.browserName} ${params.name}`;
      }
    },
    tooltip: secondTooltip,
    data: chartData.map(b => {
      if (b.show || b.show === undefined) {
        return b.version.map(v => {
          return {
            name: v.key,
            value: v.doc_count,
            browserName: b.key
          }
        })
      }
    }).filter(d => !!d).reduce((prev, cur) => {
      prev.push(...cur);
      return prev;
    }, [])
  }
}

export default {
  components: {
    search
  },
  data: function() {
    return {
      loading: false,
      params: {}
    }
  },
  mounted() {
    
  },
  methods: {
    showCharts() {
      this.deviceChart = this.deviceChart || echarts.init(this.$refs.deviceChart, 'light');
      this.browserChart = this.browserChart || echarts.init(this.$refs.browserChart, 'light');
      this.engineChart = this.engineChart || echarts.init(this.$refs.engineChart, 'light');
      this.osChart = this.osChart || echarts.init(this.$refs.osChart, 'light');
      this.screenChart = this.screenChart || echarts.init(this.$refs.screenChart, 'light');
      this.typeChart = this.typeChart || echarts.init(this.$refs.typeChart, 'light');
      this.regionChart = this.regionChart || echarts.init(this.$refs.regionChart, 'light');
      this.ispChart = this.ispChart || echarts.init(this.$refs.ispChart, 'light');

      window.addEventListener("resize", () => {
        this.deviceChart.resize();
        this.browserChart.resize();
        this.engineChart.resize();
        this.osChart.resize();
        this.screenChart.resize();
        this.typeChart.resize();
        this.regionChart.resize();
        this.ispChart.resize();
      });

      this.loading = true;
      this.fetchList().then(() => {
        this.loading = false;
      });
    },
    fetchList() {
      const { clientType, dateRange, type } = this.params;
      const query = {
        client: clientType,
        match: JSON.stringify({ [type]: this.params[type] }),
        dateRange
      };

      // return axios
      //   .get(`/browser?${qs.stringify(query)}`)
      //   .then(response => {
      //     let { device, browser, engine, os, screen, type, region, isp } = response.data.data;

      //     this.drawDeviceChart(device);
      //     this.drawBrowserChart(browser);
      //     this.drawEngineChart(engine);
      //     this.drawOSChart(os);
      //     this.drawScreenChart(screen);
      //     this.drawTypeChart(type);
      //     this.drawRegionChart(region);
      //     this.drawIspChart(isp);
      //   })
      
      // 一次性查询全部耗时太久，改为单个查询
      return new Promise(async reslove => {
        await axios.get(`/browser?${qs.stringify({
          ...query,
          type: 'device'
        })}`).then(response => {
          this.drawDeviceChart(response.data.data);
        })
        await axios.get(`/browser?${qs.stringify({
          ...query,
          type: 'browser'
        })}`).then(response => {
          this.drawBrowserChart(response.data.data);
        })
        await axios.get(`/browser?${qs.stringify({
          ...query,
          type: 'engine'
        })}`).then(response => {
          this.drawEngineChart(response.data.data);
        })
        await axios.get(`/browser?${qs.stringify({
          ...query,
          type: 'os'
        })}`).then(response => {
          this.drawOSChart(response.data.data);
        })
        await axios.get(`/browser?${qs.stringify({
          ...query,
          type: 'screen'
        })}`).then(response => {
          this.drawScreenChart(response.data.data);
        })
        await axios.get(`/browser?${qs.stringify({
          ...query,
          type: 'type'
        })}`).then(response => {
          this.drawTypeChart(response.data.data);
        })
        await axios.get(`/browser?${qs.stringify({
          ...query,
          type: 'region'
        })}`).then(response => {
          this.drawRegionChart(response.data.data);
        })
        await axios.get(`/browser?${qs.stringify({
          ...query,
          type: 'isp'
        })}`).then(response => {
          this.drawIspChart(response.data.data);
        })
        reslove();
      })
    },
    drawDeviceChart(chartData) {
      this.deviceChart.setOption({
        title: {
          text: '设备型号',
          textAlign: 'center',
          left: '50%'
        },
        tooltip: firstTooltip,
        legend: legend(chartData),
        series: [
          {
            name:'设备厂商',
            ...firstSeries(chartData)
          },
          {
            name:'型号',
            ...secondSeries(chartData)
          }
        ]
      })
    },
    drawBrowserChart(chartData) {
      this.browserChart.setOption({
        title: {
          text: '浏览器',
          textAlign: 'center',
          left: '50%'
        },
        tooltip: firstTooltip,
        legend: legend(chartData),
        series: [
          {
            name:'浏览器类型',
            ...firstSeries(chartData)
          },
          {
            name:'版本号',
            ...secondSeries(chartData)
          }
        ]
      })
    },
    drawEngineChart(chartData) {
      this.engineChart.setOption({
        title: {
          text: '浏览器引擎',
          textAlign: 'center',
          left: '50%'
        },
        tooltip: firstTooltip,
        legend: legend(chartData),
        series: [
          {
            name:'浏览器引擎类型',
            ...firstSeries(chartData)
          },
          {
            name:'版本号',
            ...secondSeries(chartData)
          }
        ]
      })
    },
    drawOSChart(chartData) {
      this.osChart.setOption({
        title: {
          text: '操作系统',
          textAlign: 'center',
          left: '50%'
        },
        tooltip: firstTooltip,
        legend: legend(chartData),
        series: [
          {
            name:'操作系统',
            ...firstSeries(chartData)
          },
          {
            name:'版本号',
            ...secondSeries(chartData)
          }
        ]
      })
    },
    drawScreenChart(chartData) {
      this.screenChart.setOption({
        title: {
          text: '屏幕分辨率',
          textAlign: 'center',
          left: '50%'
        },
        tooltip: firstTooltip,
        legend: legend(chartData),
        series: [
          {
            name:'屏幕分辨率',
            ...Object.assign(firstSeries(chartData), {
              label: {
                normal: {
                  formatter: function(params) {
                    return `${params.name} ${params.percent}%`;
                  }
                }
              },
              labelLine: {
                normal: {
                  show: true
                }
              }
            })
          }
        ]
      })
    },
    drawTypeChart(chartData) {
      this.typeChart.setOption({
        title: {
          text: '设备类型',
          textAlign: 'center',
          left: '50%'
        },
        tooltip: firstTooltip,
        legend: legend(chartData),
        series: [
          {
            name:'设备类型',
            ...Object.assign(firstSeries(chartData), {
              label: {
                normal: {
                  formatter: function(params) {
                    return `${params.name} ${params.percent}%`;
                  }
                }
              },
              labelLine: {
                normal: {
                  show: true
                }
              }
            })
          }
        ]
      })
    },
    drawRegionChart(chartData) {
      //数据纯属虚构
      var data = getRegionData(chartData);

      var yData = [];
      var barData = [];

      for (var i = 0; i < 10; i++) {
        barData.push(data[i]);
        yData.push(i + data[i].name);
      }

      this.regionChart.setOption({
        title: {
          text: '地域分布',
          textAlign: 'center',
          left: '50%'
        },
        tooltip: {
          show: true,
          formatter: function(params) {
            return params.name + '：' + params.data.percent + '%'
          }
        },
        visualMap: {
          type: 'continuous',
          orient: 'horizontal',
          itemWidth: 10,
          itemHeight: 80,
          text: ['高', '低'],
          showLabel: true,
          seriesIndex: [0],
          min: 0,
          max: Math.max.apply(Math, data.map(d => d.value)),
          inRange: {
            color: ['#ffffff','#2F95FA']
          },
          textStyle: {
            color: '#7B93A7'
          },
          bottom: 30,
          left: 'left',
        },
        grid: {
          right: 10,
          bottom: 0,
          width: '20%'
        },
        xAxis: {
          show: false
        },
        yAxis: {
          type: 'category',
          inverse: true,
          nameGap: 16,
          axisLine: {
              show: false,
              lineStyle: {
                  color: '#ddd'
              }
          },
          axisTick: {
              show: false,
              lineStyle: {
                  color: '#ddd'
              }
          },
          axisLabel: {
            interval: 0,
            margin: 85,
            textStyle: {
              color: '#455A74',
              align: 'left',
              fontSize: 14
            },
            rich: {
              a: {
                color: '#fff',
                backgroundColor: '#FAAA39',
                width: 20,
                height: 20,
                align: 'center',
                borderRadius: 2
              },
              b: {
                color: '#fff',
                backgroundColor: '#4197FD',
                width: 20,
                height: 20,
                align: 'center',
                borderRadius: 2
              }
            },
            formatter: function(params) {
              if (parseInt(params.slice(0, 1)) < 3) {
                return [
                  '{a|' + (parseInt(params.slice(0, 1)) + 1) + '}' + '  ' + params.slice(1)
                ].join('\n')
              } else {
                return [
                  '{b|' + (parseInt(params.slice(0, 1)) + 1) + '}' + '  ' + params.slice(1)
                ].join('\n')
              }
            }
          },
          data: yData
        },
        geo: {
          // roam: true,
          map: 'china',
          left: 'left',
          // right: '300',
          // layoutSize: '80%',
          label: {
            emphasis: {
              show: false
            }
          },
          itemStyle: {
            emphasis: {
              areaColor: '#fff464'
            }
          }
        },
        series: [{
          name: 'mapSer',
          type: 'map',
          roam: false,
          geoIndex: 0,
          label: {
            show: false,
          },
          data: data
        }, {
          name: 'barSer',
          type: 'bar',
          roam: false,
          visualMap: false,
          zlevel: 2,
          barMaxWidth: 8,
          barGap: 0,
          itemStyle: {
            normal: {
              color: function(params) {
                // build a color map as your need.
                var colorList = [{
                  colorStops: [{
                    offset: 0,
                    color: '#FFD119' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: '#FFAC4C' // 100% 处的颜色
                  }]
                },
                {
                  colorStops: [{
                    offset: 0,
                    color: '#00C0FA' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: '#2F95FA' // 100% 处的颜色
                  }]
                }];
                if (params.dataIndex < 3) {
                  return colorList[0]
                } else {
                  return colorList[1]
                }
              },
              barBorderRadius: 15
            }
          },
          data: barData
        }]
      })
    },
    drawIspChart(chartData) {
      this.ispChart.setOption({
        title: {
          text: '运营商',
          textAlign: 'center',
          left: '50%'
        },
        tooltip: firstTooltip,
        legend: legend(chartData),
        series: [
          {
            name:'运营商',
            ...Object.assign(firstSeries(chartData), {
              label: {
                normal: {
                  formatter: function(params) {
                    return `${params.name} ${params.percent}%`;
                  }
                }
              },
              labelLine: {
                normal: {
                  show: true
                }
              }
            })
          }
        ]
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 30px;
}
.charts {
  display: flex;
  flex-flow: wrap;
  margin-top: 20px;
}
.chart {
  width: 50%;
  height: 500px;
  margin-bottom: 50px;
}
</style>
